export default {"src":"/_next/static/media/less-prevention.3bee2c28.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};